// @TODO: generate this map from the tokens

import {
  SizeBreakpointXs,
  SizeBreakpointSmMinus,
  SizeBreakpointSm,
  SizeBreakpointMd,
  SizeBreakpointMdPlus,
  SizeBreakpointLg,
  SizeBreakpointXl,
  SizeBreakpointXxl
} from '~styles/dist/tokens.mjs'

export const breakpoints = {
  'xs': SizeBreakpointXs,
  'sm-minus': SizeBreakpointSmMinus,
  'sm': SizeBreakpointSm,
  'md': SizeBreakpointMd,
  'md-plus': SizeBreakpointMdPlus,
  'lg': SizeBreakpointLg,
  'xl': SizeBreakpointXl,
  'xxl': SizeBreakpointXxl
}